import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { BrandActions, BrandState } from '../types';

import { initialBrandState } from '.';
import { createBrandFileAsync } from './../actions';

const createBrandFileReducer: Reducer<BrandState, BrandActions> = (state = initialBrandState, action) => {
  switch (action.type) {
    case getType(createBrandFileAsync.request): {
      return {
        ...state,
        createBrandFile: {
          ...state.createBrandFile,
          isError: false,
          isPending: true,
          createdFile: null
        }
      };
    }
    case getType(createBrandFileAsync.success): {
      return {
        ...state,
        createBrandFile: {
          ...state.createBrandFile,
          isPending: false,
          createdFile: action.payload
        }
      };
    }
    case getType(createBrandFileAsync.failure): {
      return {
        ...state,
        createBrandFile: {
          ...state.createBrandFile,
          isError: true,
          isPending: false,
          error: action.payload
        }
      };
    }
    default:
      return state;
  }
};

export default createBrandFileReducer;
